import React from "react";
import Layout from "./Layouts";

const PageWrapper = ({ children }) => {
    return (
        <>
            <Layout>
                {children}
            </Layout>
        </>
    );
};

export default PageWrapper;
